module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [(_vm.row.club2grade) ? _c('van-notice-bar', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyClub'
      }),
      expression: "{name:'MyClub'}"
    }],
    attrs: {
      "text": "您已具备申请二星俱乐部资质，请尽快升级俱乐部资质。点击前往>>"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v(_vm._s(_vm.pageData.sqname)), _c('br'), _vm._v("扫码加工作人员好友，进入赛事微信群")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.hotel_list), function(hvalue, hindex) {
    return _c('div', {
      key: hindex
    }, [(hvalue.qrpic.length > 0) ? _c('img', {
      attrs: {
        "src": hvalue.qrpic_url
      }
    }) : _vm._e(), _vm._v(" "), (hvalue.qrpic.length > 0) ? _c('p', {
      staticStyle: {
        "color": "#f00"
      }
    }, [_vm._v("扫码进入 " + _vm._s(hvalue.title) + " 咨询群")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "队伍",
      "value": _vm.row.mingcheng
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "赛区",
      "value": _vm.row.saiqu_name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.row.need_video == 1) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyVideoList',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyVideoList',query:{id:row.id}}"
    }],
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v(_vm._s(_vm.row.video_ok ? '视频已上传' : '上传视频'))]) : _vm._e()], 1), _vm._v(" "), _c('van-divider', [_vm._v("秩序册信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "赛季",
      "value": _vm.pageData.sjname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛区",
      "value": _vm.pageData.sqname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.pageData.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.pageData.mingcheng
    }
  }), _vm._v(" "), (_vm.pageData.heying) ? _c('van-cell', {
    attrs: {
      "title": "队伍合影"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pageData.heying
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.pageData.heying
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('van-divider', [_vm._v("人员信息")]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.lingdui_list), function(user, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": "领队",
        "value": user.name
      },
      on: {
        "click": function($event) {
          return _vm.downloadMemberCert(user)
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_vm._v(" \n                    身份证:" + _vm._s(user.num) + " "), (_vm.pageData.showCert && user.showCert) ? _c('van-button', {
            on: {
              "click": function($event) {
                return _vm.downloadMemberCert(user)
              }
            }
          }, [_vm._v("下载证书")]) : _vm._e()]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.jiaolianyuan_list), function(user, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '教练员' + (index + 1),
        "value": user.name
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_vm._v(" \n                  身份证:" + _vm._s(user.num) + " "), (_vm.pageData.showCert && user.showCert) ? _c('van-button', {
            on: {
              "click": function($event) {
                return _vm.downloadMemberCert(user)
              }
            }
          }, [_vm._v("下载证书")]) : _vm._e()]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.caipanyuan_list), function(user, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '裁判员' + (index + 1),
        "value": user.name,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.openCaipanProjectPopup(user, index)
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_vm._v("\n                    身份证:" + _vm._s(user.num)), _c('br'), _vm._v("\n                    执裁项目: " + _vm._s(_vm.formatCaipanProjects(user.project)) + "\n                ")]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.yundongyuan_list), function(user, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '运动员' + (index + 1),
        "value": user.name
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_vm._v(" \n                  身份证:" + _vm._s(user.num) + " "), (_vm.pageData.showCert && user.showCert) ? _c('van-button', {
            on: {
              "click": function($event) {
                return _vm.downloadMemberCert(user)
              }
            }
          }, [_vm._v("下载证书")]) : _vm._e()]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-divider', [_vm._v("参赛人数")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "领队",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "教练员",
      "value": _vm.pageData.jiaolianyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "裁判员",
      "value": _vm.pageData.caipanyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "运动员",
      "value": _vm.pageData.yundongyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "总计",
      "value": _vm.pageData.member_total_count
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MineIndex',
        query: {}
      }),
      expression: "{name:'MineIndex',query:{}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载明细表")])], 1), _vm._v(" "), _vm._l((_vm.pageData.subject), function(subject, index) {
    return _c('div', [_c('van-divider', [_vm._v("项目" + _vm._s(index + 1))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "title": "项目",
        "label": subject.subject_name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "参赛队员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length > 0),
        expression: "subject.yundongyuan.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        运动员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.yundongyuan.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                        ")])], 1)
    }), 0), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "教练员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.jiaolian.length > 0),
        expression: "subject.jiaolian.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.jiaolian), function(jiaolian, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        教练员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                        ")])], 1)
    }), 0), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "替补队员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.tbydy.length > 0),
        expression: "subject.tbydy.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.tbydy), function(tbydy, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        替补运动员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(tbydy.name) + " " + _vm._s(tbydy.num) + "\n                        ")])], 1)
    }), 0), _vm._v(" "), (subject.sf_music_status == false && subject.music_url) ? _c('van-cell', {
      attrs: {
        "title": "自选音乐",
        "is-link": ""
      }
    }, [_c('a', {
      attrs: {
        "href": subject.music_url
      }
    }, [_vm._v("已上传")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url == '' && subject.music_status == 1) ? _c('van-cell', {
      attrs: {
        "title": "自选音乐",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          _vm.showMusicDialog = true;
          _vm.musicSubjectId = subject.id
        }
      }
    }, [_c('em', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("现在上传/现场提交")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url && subject.music_status == 1) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.listen(subject)
        }
      }
    }, [_c('em', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("未试听,请点击确认试听")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url && subject.music_status == 2) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听"
      }
    }, [_vm._v("\n                     已试听\n                ")]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_status == 3) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听"
      }
    }, [_vm._v("\n                     现场提交并核对\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.pageData.room_list.length > 0) ? _c('div', [_c('van-divider', [_vm._v("食宿信息")]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.orderData2.list), function(room, rindex) {
      return _c('van-cell', {
        key: rindex,
        attrs: {
          "input-align": "right",
          "title": room.name,
          "value": room.count
        }
      }, [_c('span', [_vm._v("\n                    " + _vm._s(room.count) + "\n                    ")])])
    }), 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  }), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showCert),
      callback: function($$v) {
        _vm.showCert = $$v
      },
      expression: "showCert"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      padding: '0 0 0.32rem'
    }),
    attrs: {
      "position": "bottom",
      "round": ""
    },
    on: {
      "closed": _vm.onCaipanProjectPopupClosed
    },
    model: {
      value: (_vm.showCaipanProjectPopup),
      callback: function($$v) {
        _vm.showCaipanProjectPopup = $$v
      },
      expression: "showCaipanProjectPopup"
    }
  }, [_c('div', {
    staticClass: "caipan-project-popup"
  }, [_c('div', {
    staticClass: "caipan-project-popup__title"
  }, [_vm._v("选择执裁项目")]), _vm._v(" "), (_vm.caipanProjectEditName) ? _c('div', {
    staticClass: "caipan-project-popup__sub"
  }, [_vm._v(_vm._s(_vm.caipanProjectEditName))]) : _vm._e(), _vm._v(" "), _c('van-checkbox-group', {
    model: {
      value: (_vm.tempCaipanProjects),
      callback: function($$v) {
        _vm.tempCaipanProjects = $$v
      },
      expression: "tempCaipanProjects"
    }
  }, [_c('div', {
    staticClass: "caipan-project-popup__list"
  }, _vm._l((_vm.caipanProjectOptions), function(opt) {
    return _c('van-checkbox', {
      key: opt,
      staticClass: "caipan-project-popup__item",
      attrs: {
        "shape": "square",
        "name": opt,
        "checked-color": "#fead19"
      }
    }, [_vm._v("\n                            " + _vm._s(opt) + "\n                        ")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "caipan-project-popup__actions"
  }, [_c('van-button', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "round": "",
      "size": "large",
      "disabled": _vm.caipanProjectSaveLoading
    },
    on: {
      "click": function($event) {
        _vm.showCaipanProjectPopup = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "round": "",
      "size": "large",
      "type": "primary",
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "loading": _vm.caipanProjectSaveLoading,
      "disabled": _vm.caipanProjectSaveLoading,
      "loading-text": "保存中..."
    },
    on: {
      "click": _vm.saveCaipanProjects
    }
  }, [_vm._v("保存")])], 1)], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7ed68f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormSuccess.vue
// module id = 2250
// module chunks = 0